import { MY_ZETRIX_LOGO } from '../config/enumeration/index'
export default {
  'search': {
    'placeholder': 'Block height, transaction hash, address',
    'errorTips': 'Invalid block height/transaction hash/address',
    'inputPlaceholder': 'Please enter the block height, transaction hash or account address',
    'errWarning': 'Block height/transaction hash/account address error',
    'errorTipsTokens': 'Invalid token/contract address'
  },
  'common': {
    'time': {
      's': 'Seconds ago',
      'm': 'Minutes ago',
      'h': 'Hours ago'
    },
    'nav': {
      'index': 'Home',
      'txList': 'Transactions',
      'token': 'Tokens',
      'nft': 'NFTs',
      'more': 'More',
      'export': 'CSV Export'
    },
    'txType': {
      'payCoin': `Transfer ${MY_ZETRIX_LOGO}`,
      'invokeContract': 'Call Contract',
      'createContract': 'Deploy Contract',
      'issueAsset': 'Issue Asset',
      'createAccount': 'Create Account',
      'unknown': 'Account',
      'payAsset': 'Transfer Asset'
    },
    'txStatus': {
      'success': 'Success',
      'fail': 'Failure'
    },
    'errorMsg': {
      'dealing': 'Transaction is processing',
      'noBalance': 'Insufficient balance',
      'noActive': 'Insufficient balance to activate the account',
      'unknownError': 'Unknown Error'
    },
    'accType': {
      'normal': 'Normal Account',
      'unite': 'Joint Account',
      'contract': 'Contract Account'
    },
    'tabelName': {
      'time': 'Time',
      'age': 'Age',
      'block': 'Block',
      'txtype': 'Method',
      'fromAddress': 'From',
      'toAddres': 'To',
      'amount': 'Value',
      'hash': 'Transaction Hash',
      'status': 'Status',
      'fee': 'Fee'
    },
    'btn': {
      'json': 'Raw JSON',
      'formate': 'Format',
      'unFormate': 'Original Format',
      'switchTo': 'Decrypt',
      'switchBack': 'Encrypt',
      'testBtn': 'Testnet Endpoint',
      'mainBtn': 'Mainnet Endpoint',
      'showAll': 'Expand',
      'showLess': 'Collapse'
    },
    'nomace': 'Transactions',
    'hashError': 'Transaction hash does not exist',
    'accountError': 'Invalid destination address',
    'blockError': 'Block does not exist',
    'tokenError': 'Token does not exist',
    'tableNoData': 'No Data',
    'tableLoading': 'Loading...',
    'webkitWarn': 'Tips: It is recommended to use Chrome or Safari browser for a better user experience'
  },
  'index': {
    'hoverMessage': {
      'price': 'Current value of Zetrix',
      'transactions': 'Total Transactions Counter',
      'tps': 'Transactions per Seconds',
      'marketCap': 'Total market value of Zetrix in circulation',
      'totalSupply': 'Total number of Zetrix available',
      'blockHeight': 'Number of blocks in the blockchain',
      'blockTime': 'Average time it takes to mine a new block',
      'uniqueAddr': 'Total number of distinct Zetrix addresses used',
      'nodes': 'Number of computers that maintain the Zetrix network',
      'reward': 'Block Reward',
      'amount': 'Amount'
    },
    'panelCard1': {
      'column1row1': 'ZETRIX PRICE',
      'column1row2': 'MARKET CAP',
      'column2row1': 'TRANSACTIONS',
      'column2row2': 'TOTAL SUPPLY'
    },
    'panelCard2': '14 DAYS TRANSACTION HISTORY',
    'broadColumn': {
      'col1': 'BLOCK HEIGHT',
      'col2': 'AVG. BLOCK TIME',
      'col3': 'UNIQUE ADDRESSES',
      'col4': 'NODES'
    },
    'totalData': {
      'title': 'Overview',
      'node': 'ACTIVE NODES',
      'seq': 'BLOCK HEIGHT',
      'intervals': 'Intervals',
      'averageTime': 'AVERAGE BLOCK TIME',
      'price': `${MY_ZETRIX_LOGO}  price`,
      'lastBlock': 'Lastest Block',
      'txNum': 'TRANSACTIONS',
      'accountNum': 'ACCOUNTS',
      'days': 'Online days',
      'day': 'Day',
      'chartsTitle': `14 days ${MY_ZETRIX_LOGO} Transaction History`,
      'chartsTips': 'Number of transactions',
      'more': 'More'
    },
    'block': {
      'title': 'Blocks',
      'secTitle': '（Latest）',
      'label': {
        'time': 'Time',
        'age': 'Age',
        'height': 'Block',
        'size': 'Size（Byte）',
        'reward': 'Block Reward',
        'hash': 'Block Hash'
      }
    },
    'tx': {
      'title': 'Transactions',
      'secTitle': '（Latest）',
      'label': {
        'time': 'Time',
        'age': 'Age',
        'block': 'Block',
        'txType': 'Method',
        'fromAddress': 'From',
        'toAddress': 'To',
        'amount': 'Value',
        'hash': 'Transaction Hash',
        'status': 'Status',
        'fee': 'Fee',
        'clickToShowDatetime': 'Click to show Datetime format',
        'clickToShowAge': 'Click to show Age format'
      }
    }
  },
  'account': {
    'baseInfo': {
      'title': 'Account',
      'titleAddress': 'Address',
      'itemName': {
        'balance': 'Balance',
        'accType': 'Account Type',
        'siners': 'Members of Joint-Account',
        'thresholds': 'Threshold',
        'contract': 'Contract Code',
        'value': 'Value (USD)',
        'tokenHolding': 'Token Holding',
        'contractCreator': 'Contract Creator',
        'lastTxSent': 'Last Transaction Sent',
        'firstTxSent': 'First Transaction Sent',
        'tokenTracker': 'Token Tracker',
        'rawJson': 'Raw JSON'
      }
    },
    'asset': {
      'listName': 'ZTP10 Assets List',
      'assetName': 'Asset ID',
      'amount': 'Amount',
      'address': 'Address'
    },
    'asset20': {
      'listName': 'ZTP20 Assets List',
      'assetCode': 'Asset ID',
      'assetName': 'Asset Name',
      'amount': 'Amount',
      'contract': 'Asset Contract'
    },
    'asset721': {
      'title': 'ZTP721',
      'listName': 'ZTP721 Assets List'
    },
    'asset1155': {
      'title': 'ZTP1155',
      'listName': 'ZTP1155 Assets List'
    },
    'lastTx': {
      'moreLink': 'View All',
      'listName': 'Latest 5 Transactions'
    },
    'accountTxList': {
      'title': 'Transaction: Account'
    }
  },
  'block': {
    'baseInfo': {
      'title': 'Block',
      'itemName': {
        'blockReward': 'Block Reward',
        'txCount': 'Number of transactions',
        'seq': 'Block Height',
        'ledgerSize': 'Block Size',
        'version': 'Block Version',
        'time': 'Block Producing Time',
        'hash': 'Hash',
        'previousHash': 'Previous Block Hash',
        'accountTreeHash': 'MerkleTree Hash',
        'consensusValueHash': 'Consensus Value Hash',
        'validatorsHash': 'Consensus Node Hash'
      },
      'prevBlockBtn': 'Previous Block',
      'nextBlockBtn': 'Next Block'
    },
    'blockTx': {
      'title': 'Transactions included'
    }
  },
  'tx': {
    'list': {
      'listTitle': 'Transaction list'
    },
    'baseInfo': {
      'title': 'Transaction Hash',
      'itemName': {
        'time': 'Time',
        'age': 'Age',
        'ledgerSeq': 'Block Height',
        'txType': 'Transaction Status',
        'fee': 'Transaction Fee',
        'sourceAddress': 'Source address',
        'signatureStr': 'Signers',
        'blockNumber': 'Block Number',
        'method': 'Method',
        'fromAddress': 'From address',
        'toAddress': 'Interact with (To)',
        'amount': 'Amount',
        'metaData': 'Memo',
        'code': 'Code',
        'methodMint': 'ZTP-721 Tokens Transferred',
        'moreDetails': 'More Details',
        'showMore': 'Click to show more',
        'showLess': 'Click to show less',
        'input': 'Input',
        'contractAction': 'Contract Action',
        'tokenZTP721': 'ZTP-721 Tokens Transferred',
        'tokenZTP1155': 'ZTP-1155 Tokens Transferred',
        'typeTransaction': 'Type of Transaction',
        'accountType': 'Account Type',
        'assetCode': 'Asset Code',
        'createAccount': 'Create Account',
        'createContract': 'Create Contract',
        'token': 'Token',
        'transfer': 'Transfer',
        'transferFrom': 'Transfer From',
        'to': 'To',
        'log': 'Log',
        'transactionItem': 'Transaction Item',
        'from': 'From',
        'zTP20TokensTransferred': 'ZTP20 Tokens Transferred',
        'metadata': 'Set Metadata',
        'multipleRecipients': 'Multiple Recipients'
      }
    },
    'operate': {
      'title': 'Operation',
      'secTitle': '（Creating accounts, Sending Token, Calling contracts, Issuing assets）',
      'payCoin': {
        'name': `Transfer  ${MY_ZETRIX_LOGO}`,
        'itemName': {
          'fromAddress': 'From',
          'toAddress': 'To',
          'amount': 'Amount'
        }
      },
      'payAsset': {
        'name': 'Send Token',
        'itemName': {
          'fromAddress': 'From',
          'toAddress': 'To',
          'assetCode': 'Asset Code',
          'amount': 'Amount'
        }
      },
      'createAccount': {
        'name': 'Create Account',
        'itemName': {
          'destAddress': 'Address',
          'initBalance': 'Initial Balance',
          'accType': 'Account Type',
          'signers': 'Members of Joint-Account',
          'thresholds': 'Threshold'
        }
      },
      'createContract': {
        'name': 'Deploy Contract',
        'itemName': {
          'destAddress': 'Contract Address',
          'initBalance': 'Initial Balance',
          'contract': 'Contract source code'
        }
      },
      'issueAsset': {
        'name': 'Issue Token',
        'itemName': {
          'assetIssuer': 'Issuer Address',
          'assetCode': 'Asset Code',
          'amount': 'Amount'
        }
      },
      'invokeContract': {
        'name': 'Call Contract',
        'itemName': {
          'fromAddress': 'From',
          'toAddress': 'Contract address'
        }
      }
    }
  },
  'blockList': {
    'title': 'Block Height',
    'blockNum': 'Block Number',
    'time': 'Time',
    'txnCount': 'Transaction Count',
    'blockSize': 'Block Size (Bytes)',
    'reward': 'Rewards'
  },
  'token': {
    'tokenPlaceholder': 'Enter token name or contract address',
    'overFlow': 'Warning: The Issuer has issued more than the total supply',
    'list': {
      'title': 'Token list',
      'title1': 'Token list',
      'tableTitle': 'Tokens',
      'assetCode': 'Asset code',
      'tokenType': 'Token type',
      'ATPLimited': 'ZTP Limited',
      'ATPIncremented': 'ZTP Incremented',
      'ATPUnlimited': 'ZTP Unlimited',
      'CTPFixed': 'CTP Fixed',
      'totalSupply': 'Total Supply',
      'contractAddress': 'Contract address',
      'issueAddress': 'Issuer address',
      'assetType': 'Asset type',
      'assetContractType': 'Asset contract type',
      'decimals': 'Precision',
      'holderCount': 'Number of asset holders',
      'txCount': 'Number of transaction',
      'operation': 'Operations',
      'detail': 'Details',
      'nolimit': 'Infinite',
      'ztpType': 'ZTP Type',
      'tokenName': 'Token'
    },
    'detail': {
      'title': 'Asset (Token)',
      'tokenDetailTitle': 'Token Detail',
      'profileSummary': 'Profile Summary',
      'overview': 'Overview',
      'tran': 'Transactions',
      'tabs': {
        'transaction': 'Transactions',
        'holder': 'Holders'
      },
      'txList': {
        'title': 'Transaction list',
        'time': 'Transaction time',
        'block': 'Block Location',
        'type': 'Method',
        'sourceAccount': 'Source address',
        'destAccount': 'Destination address',
        'amount': 'Amount ',
        'hash': 'Transaction hash',
        'status': 'Status'
      },
      'tranList': {
        'time': 'Time',
        'age': 'Age',
        'block': 'Block',
        'type': 'Method',
        'from': 'From',
        'to': 'To',
        'value': 'Value',
        'hash': 'Hash',
        'status': 'Status',
        'fee': 'Fee'
      },
      'overviewDetail': {
        'tokenName': 'Token name',
        'totalSupply': 'Total supply',
        'totalSupplyTip': 'The total number of tokens issued on the blockchain network',
        'issuingTime': 'Issuing time',
        'issuingTimeTip': "Date of Token's Issuance",
        'issuingAddress': 'Issuing address',
        'issuingAddressTip': 'The Account that issued the Token',
        'holders': 'Holders',
        'holdersTip': 'Accounts Holding the Token',
        'contractAddress': 'Contract address',
        'contractAddressTip': 'The smart contract which issued ZTP20 Token',
        'officialWebsite': 'Official website',
        'officialWebsiteTip': 'The Official Website of the Project',
        'decimals': 'Decimals',
        'decimalsTip': 'Maximum Decimal Supported by the Token',
        'tokenProtocols': 'Token protocols',
        'tokenProtocolsTip': 'The protocol type of the token issued on the blockchain network',
        'price': 'Token Price (USD)',
        'priceTip': 'The current token price in USD'
      },
      'pubRecord': {
        'title': 'Issue records',
        'amount': 'Amount',
        'txHash': 'Transaction hash',
        'time': 'Issued date'
      },
      'holderAddr': {
        'title': 'Asset holders list',
        'address': 'Address',
        'balance': 'Balance',
        'percent': 'Percentage'
      }
    },
    'tokenId': {
      'ownAddress': 'Own address',
      'transferNum': 'Number of transfer',
      'txDetail': 'Transaction detail'
    }
  },
  'nfts': {
    'detail': {
      'baseInfo': {
        'title': 'NFT Detail'
      },
      'overview': {
        'title': 'Overview',
        'property': {
          'creator': 'Creator address',
          'creatorTip': 'The smart contract which issued ZTP Token',
          'contractAddress': 'Contract address',
          'contractAddressTip': 'The smart contract which issued ZTP Token',
          'issuingTime': 'Issuing Time',
          'issuingTimeTip': 'The time when the NFT smart contract is deployed',
          'holders': 'Holders',
          'holdersTip': 'The number of NFT accounts held under the smart contract',
          'officialWebsite': 'Official Website',
          'officialWebsiteTip': 'This publisher\'s official website address',
          'tokenProtocols': 'Token protocols',
          'tokenProtocolsTip': 'The protocol type of the token issued on the blockchain network'
        }
      },
      'optTabs': {
        'title': {
          'txs': 'Transactions',
          'inventory': 'Inventory',
          'contactCode': 'Contact code'
        }
      }
    },
    'tokenId': {
      'baseInfo': {
        'title': 'NFT Overview'
      },
      'holders': {
        'tabs': {
          'title': 'Holders',
          'table': {
            'col': {
              'holder': 'Holders',
              'quantity': 'Quantity'
            }
          }
        }
      }
    }
  },
  'more': {
    'export': {
      'title': 'Download Data (CSV Export)',
      'input': {
        'type': 'Select export type',
        'address': 'Address',
        'accAddress': 'Account Address',
        'contract': 'Contract Address',
        'token': 'Token Contract Address',
        'accAddressTokenId': 'Account Address / Token ID',
        'option': 'Choose download option:',
        'date': 'Date',
        'block': 'Block Number',
        'startDate': 'Start Date',
        'endDate': 'End Date',
        'download': 'Download',
        'reset': 'Reset'
      },
      'info': {
        'desc': 'The information you requested can be downloaded from this page. Before continuing please verify that you are not a robot by completing the captcha below.',
        'limit': 'The earliest 5,000 records within the selected range will be exported'
      }
    }
  }
}
